// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"17":"1f0b46a8e3f97b0c","187":"b01d69af4d090bab","716":"08c41d06562f5d6e","737":"3ed04a74512f9d57"}[chunkId] + ".js";
};